import { render } from "./materialTable.vue?vue&type=template&id=01b36fe4&ts=true"
import script from "./materialTable.vue?vue&type=script&lang=ts"
export * from "./materialTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__